import type { JSX } from "react";
import type { ButtonProps, ButtonTypeMap } from "@mui/material";
import type { ValueOrI18nKeyProp } from "../../util/type";
import { Button, Tooltip } from "@mui/material";
import { useServices } from "../../services/services-context";


export type TextButtonProps<D extends React.ElementType, P> = Omit<ButtonProps<D, P>, "children"> & ValueOrI18nKeyProp<"label"> & Partial<ValueOrI18nKeyProp<"tooltip">> & {
	target?: "_blank" | undefined;
};

export const TextButton = <D extends React.ElementType = ButtonTypeMap["defaultComponent"], P = {}>({ label, labelKey, labelValues, tooltip, tooltipKey, tooltipValues, ...buttonProps }: TextButtonProps<D, P>): JSX.Element => {  // eslint-disable-line @typescript-eslint/no-empty-object-type
	const { translation } = useServices();

	const button = (
		<Button { ...buttonProps }>
			{ translation.resolveValueOrI18nKey(label, labelKey, labelValues) }
		</Button>
	);

	const tooltipTitle = translation.resolveValueOrI18nKey(tooltip, tooltipKey, tooltipValues, null);

	if(tooltipTitle && !buttonProps.disabled) {
		return (
			<Tooltip title={ tooltipTitle }>
				{ button }
			</Tooltip>
		);
	}

	return button;
};
